import { formatDate, addTime } from '@perch-labs/warbler';
import { copyFor } from 'config';
import Credits from '/images/dashboard-page/credits.svg';
import Waitlist from '/images/dashboard-page/waitlist.svg';
import Pending from '/images/dashboard-page/pending.svg';
import { getSolarProjectName } from 'utils/format';

const getCopy = copyFor('dashboard.standardDashboard.plans.vnmStatus');

interface DateCopyVariables {
  time: string;
  timeframe: string;
}

const getDateCopyVariables = (projectStartDate?: Date): DateCopyVariables => {
  if (!projectStartDate) return { time: '', timeframe: '' };

  const format = 'MMMM yyyy';
  const time = formatDate(projectStartDate, { format });
  const nextMonth = formatDate(addTime(projectStartDate, { months: 1 }), {
    format: 'MMMM',
  });
  const followingMonthAndYear = formatDate(
    addTime(projectStartDate, { months: 2 }),
    { format }
  );
  const timeframe = `${nextMonth}-${followingMonthAndYear}`;
  return { time, timeframe };
};

interface Props {
  projectStartDate?: Date;
  projectName?: string;
  percentSavings?: number;
}

interface Style {
  color: string;
  svg: string;
  text: string;
  title: string;
}

interface StyleMap {
  firstSolarStatement: Style;
  pending: Style;
  waitlistLive: Style;
  waitlistNotLive: Style;
}

export const getStyleMap = ({
  projectName,
  percentSavings,
  projectStartDate,
}: Props): StyleMap => {
  const { time, timeframe } = getDateCopyVariables(projectStartDate);
  return {
    firstSolarStatement: {
      color: 'success',
      svg: Credits,
      text: getCopy('firstSolarStatement.text', {
        percentSavings,
        projectName: projectName && getSolarProjectName(projectName),
      }),
      title: getCopy('firstSolarStatement.title'),
    },
    pending: {
      color: 'accent1',
      svg: Pending,
      text: getCopy('pending.text'),
      title: getCopy('pending.title'),
    },
    waitlistLive: {
      color: 'accent1',
      svg: Waitlist,
      text: getCopy('waitlistLive.text'),
      title: getCopy('waitlistLive.title'),
    },
    waitlistNotLive: {
      color: 'accent1',
      svg: Waitlist,
      text: getCopy('waitlistNotLive.text', {
        time,
      }),
      title: getCopy('waitlistNotLive.title', {
        timeframe,
      }),
    },
  };
};
